import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Events, subscribe } from '@conversion-cloud-widget/pubsub';

const BaseStack = styled.div`
    background-color: #ffffff;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.24);
    color: #181818;
    height: 16px;
    position: relative;
`;

const TopCard = styled(BaseStack)`
    width: 300px;

    &.bottom {
        bottom: 24px;

        &.left {
            left: 8px;
        }

        &.middle {
            margin-left: 8px;
        }

        &.right {
            right: -8px;
        }
    }

    &.top {
        top: -24px;

        &.left {
            left: 8px;
        }
        &.right {
            right: -8px;
        }
    }
`;

const BottomCard = styled(BaseStack)`
    width: 280px;

    &.bottom {
        bottom: 4px;

        &.left {
            left: 16px;
        }

        &.middle {
            margin-left: 16px;
        }

        &.right {
            right: -16px;
        }
    }

    &.top {
        top: -4px;

        &.left {
            left: 16px;
        }

        &.right {
            right: -16px;
        }
    }
`;

const ModuleBarStack = ({ xPosition, yPosition }) => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        subscribe(Events.MODULE_OPENED, () => {
            setShow(false);
        });
        subscribe(Events.MODULE_CLOSED, () => {
            setShow(true);
        });
    }, []);

    return (
        show && (
            <>
                <BottomCard className={`${xPosition} ${yPosition} clx-wallet-stack`} />
                <TopCard className={`${xPosition} ${yPosition} clx-wallet-stack`} />
            </>
        )
    );
};

export default ModuleBarStack;
